export interface TranslationKey {
    parentKeyId: number
    translatedValue: string
    isDone: boolean
}

export function createTranslationKey(): TranslationKey {
    return {
        parentKeyId: 0,
        translatedValue: '',
        isDone: false
    }
}